import React, { useCallback } from "react";
import { Modal } from "react-bootstrap";

import { AddPaymentMethodForm } from "components";
import { BrandingColorContext } from "components/contexts";
import { paymentTypeFieldName } from "components/pages/paymentMethods/paymentMethodForm/paymentMethodConstants";
import { CopyInfoData, PaymentTypes } from "types";

export type AddPaymentMethodModalProps = {
	show: boolean;
	onHide: () => void;
	entityId: number;
	submitService: Function;
	handleSuccessfulAddingPaymentMethod: Function;
	paymentType: string;
	copyInfoData: CopyInfoData;
	isLoadingCopyInfoData: boolean;
	isApplication?: boolean;
	isBillToAgent?: boolean;
};

const AddPaymentMethodModal = ({
	show,
	onHide,
	entityId,
	submitService,
	handleSuccessfulAddingPaymentMethod,
	paymentType,
	copyInfoData,
	isLoadingCopyInfoData,
	isApplication,
	isBillToAgent,
}: AddPaymentMethodModalProps) => {
	const onSuccess = useCallback(
		id => {
			onHide();
			handleSuccessfulAddingPaymentMethod?.(id);
		},
		[handleSuccessfulAddingPaymentMethod, onHide],
	);

	const preSelectedValues = {
		[paymentTypeFieldName]: PaymentTypes?.getByName(paymentType) || null,
	};

	return (
		<BrandingColorContext.Provider value={true}>
			<Modal
				show={show}
				onHide={onHide}
				animation={false}
				centered
				scrollable
			>
				<Modal.Header closeButton>
					<Modal.Title as="h6" className="text-center">
						Add Payment Method
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="modal-form-container">
						<AddPaymentMethodForm
							entityId={entityId}
							onSuccess={onSuccess}
							submitService={submitService}
							preSelectedValues={preSelectedValues}
							copyInfoData={copyInfoData}
							isLoadingCopyInfoData={isLoadingCopyInfoData}
							isModal
							isApplication={isApplication}
							isBillToAgent={isBillToAgent}
						/>
					</div>
				</Modal.Body>
			</Modal>
		</BrandingColorContext.Provider>
	);
};

export default AddPaymentMethodModal;
